import React from "react";
import { useDispatch } from "react-redux";
import { filterVideogamesbyGenre } from "../../actions";
import "./FilterByGenres.css"

export default function FilterGenres({setcurrentPage, allGenres}){
    const dispatch= useDispatch();
    
    
    //filtramos por genero
    function handleFilterGenres(event){
        event.preventDefault();
        dispatch(filterVideogamesbyGenre(event.target.value));
        setcurrentPage(1)

    }

    return(
        <div className="container2">
        {/*   mostramos los generos y filtramos segun el que eligan  */}
           {
           <select className="selectmain" onChange={event => handleFilterGenres(event)}>
                <option value="all">Generos</option>
                    {allGenres?.map((ele) => {
                          return (
                              <option key={ele.id} value={ele.name}  >
                                  {ele.name} 
                              </option>
                           );
                      })}
            </select>
            }
            <i></i>
        </div>      
    )


}